import { createSlice, PayloadAction } from '@reduxjs/toolkit';
type EditModeType = string | null;

interface EditModeState {
  editMode: boolean;
  editType: EditModeType;
}

const initialState: EditModeState = {
  editMode: false,
  editType: null,
};

type SetEditModePayload = | boolean | { enabled: boolean; type?: string; };

export const editModeSlice = createSlice({
  name: 'editMode',
  initialState,
  reducers: {
    SET_EDIT_MODE: (state, action: PayloadAction<SetEditModePayload>) => {
      if (typeof action.payload === 'boolean') {
        state.editMode = action.payload;
        state.editType = action.payload ? state.editType : null;
      } else {
        state.editMode = action.payload.enabled;
        state.editType = action.payload.enabled
          ? action.payload.type ?? null
          : null;
      }
    },
  },
});

export const { SET_EDIT_MODE } = editModeSlice.actions;
